import { jsx as C } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0234 3.76561C10.3164 4.071 10.4607 4.53532 10.3304 4.99912C10.0493 6.00015 10.006 7.08166 10.2516 8.16649C11.0435 11.6638 14.546 13.8609 18.0836 13.06C18.7315 12.9133 19.3341 12.6766 19.8817 12.3668C20.2999 12.1303 20.7843 12.1584 21.1509 12.3698C21.5315 12.5893 21.8177 13.034 21.73 13.5774C21.136 17.2596 18.353 20.394 14.4722 21.2727C9.38731 22.424 4.32949 19.2675 3.18404 14.2085C2.1654 9.70956 4.58736 5.23608 8.71143 3.49083C9.21895 3.27605 9.71939 3.44875 10.0234 3.76561Z",
    fill: "currentColor"
  }
);
export {
  o as default
};
